// extracted by mini-css-extract-plugin
export default {"separator":"ChatMessagesList_separator__lT5At","alienMessage":"ChatMessagesList_alienMessage__rwzqJ","userMessage":"ChatMessagesList_userMessage__jy-L-"};